import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, mergeProps as _mergeProps, createTextVNode as _createTextVNode, withKeys as _withKeys, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '../../assets/img/bobbee_hrz.png'
import _imports_1 from '../../assets/img/bobbee_mini.png'


const _hoisted_1 = ["src"]
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 2,
  class: "background_image d-flex align-start fill-height",
  style: {"width":"100%","margin":"0"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tutorial = _resolveComponent("tutorial")!
  const _component_ossAccountingFirmSelector = _resolveComponent("ossAccountingFirmSelector")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_profile_menu = _resolveComponent("profile-menu")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_SnackbarSurvey = _resolveComponent("SnackbarSurvey")!
  const _directive_scroll = _resolveDirective("scroll")!

  return (_openBlock(), _createBlock(_component_v_container, {
    raw: "",
    fluid: "",
    xs12: "",
    style: {"margin":"0","padding":"0"},
    transition: "scroll-x-transition"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_tutorial),
      (_ctx.currentUser && _ctx.currentUser.profile && _ctx.$route.name !== 'maintenance')
        ? (_openBlock(), _createBlock(_component_v_app_bar, {
            key: 0,
            app: "",
            "clipped-left": "",
            flat: "",
            class: "pa-0 ma-0",
            color: !_ctx.$vuetify.display.mobile ? 'transparent' : 'primary',
            dense: _ctx.$vuetify.display.mobile
          }, {
            default: _withCtx(() => [
              (_ctx.hasMultiAccountingFirms)
                ? (_openBlock(), _createBlock(_component_ossAccountingFirmSelector, { key: 0 }))
                : (_openBlock(), _createBlock(_component_v_toolbar_title, {
                    key: 1,
                    style: {"max-width":"256px"},
                    color: "transparent",
                    class: "d-flex justify-center align-center"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: _ctx.logo,
                        height: 40
                      }, null, 8, _hoisted_1)
                    ]),
                    _: 1
                  })),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "fill-height bg-white rounded-bs-xl px-8"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "7",
                    class: "d-flex align-center"
                  }),
                  _createVNode(_component_v_col, {
                    cols: "5",
                    class: "d-flex align-center justify-end"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_tooltip, { location: "bottom" }, {
                        activator: _withCtx(({ props }) => [
                          (
                                    _ctx.currentUser &&
                                    _ctx.currentUser.profile.configuration.internalManagement.access
                                )
                            ? (_openBlock(), _createBlock(_component_v_btn_icon, _mergeProps({
                                key: 0,
                                icon: " $oss-outlined-home "
                              }, props, {
                                color: "primary",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.accoutantHome())),
                                style: _ctx.topButtonStyle
                              }), null, 16, ["style"]))
                            : _createCommentVNode("", true)
                        ]),
                        default: _withCtx(() => [
                          _cache[13] || (_cache[13] = _createElementVNode("span", null, "Accueil", -1))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_profile_menu),
                      _createVNode(_component_oss_dialog, {
                        modelValue: _ctx.passwordChange,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.passwordChange) = $event)),
                        minWidth: "40%",
                        persistent: _ctx.firstLoginDialog,
                        "valid-title": "Modifier",
                        onValid: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changePassword()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_container, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_form, {
                                ref: "form",
                                modelValue: _ctx.valid,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.valid) = $event))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      (_ctx.firstLoginDialog)
                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                            key: 0,
                                            cols: "12",
                                            class: "pb-2"
                                          }, {
                                            default: _withCtx(() => _cache[14] || (_cache[14] = [
                                              _createTextVNode(" Afin de garantire la sécurité de votre compte, merci de créer une nouveau mot de passe ")
                                            ])),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field, {
                                            outlined: "",
                                            dense: "",
                                            required: "",
                                            type: _ctx.showPassword ? 'text' : 'password',
                                            "append-inner-icon": 
                                                _ctx.showPassword ? '$fa-eye' : '$fa-eye-slash'
                                            ,
                                            rules: [
                                                () => _ctx.password.length > 0 || 'empty password',
                                                () =>
                                                    _ctx.password === _ctx.pwdConfirmation ||
                                                    !(_ctx.pwdConfirmation.length > 0) ||
                                                    'Passwords does not match',
                                            ],
                                            onKeyup: _withKeys(_ctx.changePassword, ["enter"]),
                                            label: "Nouveau mot de passe",
                                            modelValue: _ctx.password,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                                            density: "compact",
                                            "onClick:appendInner": _cache[2] || (_cache[2] = ($event: any) => (_ctx.showPassword = !_ctx.showPassword))
                                          }, null, 8, ["type", "append-inner-icon", "rules", "onKeyup", "modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field, {
                                            outlined: "",
                                            required: "",
                                            type: "password",
                                            rules: [
                                                () =>
                                                    _ctx.pwdConfirmation.length > 0 || 'empty password',
                                                () =>
                                                    _ctx.password === _ctx.pwdConfirmation ||
                                                    !(_ctx.password.length > 0) ||
                                                    'Passwords does not match',
                                            ],
                                            onKeyup: _withKeys(_ctx.changePassword, ["enter"]),
                                            label: "Confirmer votre mot de passe",
                                            modelValue: _ctx.pwdConfirmation,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pwdConfirmation) = $event)),
                                            density: "compact"
                                          }, null, 8, ["rules", "onKeyup", "modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createVNode(_component_v_alert, {
                                type: "success",
                                "model-value": _ctx.isPasswordModified
                              }, {
                                default: _withCtx(() => [
                                  _cache[16] || (_cache[16] = _createTextVNode(" Votre mot de passe a bien ete modifie ")),
                                  _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
                                  _createVNode(_component_router_link, { to: '/login' }, {
                                    default: _withCtx(() => _cache[15] || (_cache[15] = [
                                      _createTextVNode("Se connecter")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["model-value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "persistent"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["color", "dense"]))
        : _createCommentVNode("", true),
      (_ctx.showNavigationDrawer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_ctx.mini)
              ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                  key: 0,
                  color: "primary",
                  size: "x-small",
                  elevation: "0",
                  onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.mini = !_ctx.mini), ["stop"])),
                  style: _normalizeStyle(_ctx.styleMiniBtn),
                  class: "pl-3",
                  icon: "$fa-chevron-right",
                  variant: "flat",
                  rounded: "pill"
                }, null, 8, ["style"]))
              : (_openBlock(), _createBlock(_component_v_btn_icon, {
                  key: 1,
                  color: "secondary",
                  size: "x-small",
                  elevation: "0",
                  onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.mini = !_ctx.mini), ["stop"])),
                  style: _normalizeStyle(_ctx.styleMiniBtn),
                  class: "px-0",
                  icon: "$fa-chevron-left",
                  variant: "flat",
                  rounded: "pill"
                }, null, 8, ["style"]))
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_v_navigation_drawer, {
        app: "",
        clipped: "",
        flat: "",
        color: "primary",
        floating: "",
        class: "navigation rounded-te-xl d-flex",
        rail: _ctx.mini,
        style: {"z-index":"99"}
      }, {
        append: _withCtx(() => [
          (!_ctx.mini)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 0,
                "no-gutters": "",
                class: "mb-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "3",
                    class: "d-flex justify-end align-end text--primary px-1"
                  }, {
                    default: _withCtx(() => _cache[92] || (_cache[92] = [
                      _createTextVNode(" by ")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "9",
                    class: "d-flex"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_img, {
                        src: _imports_0,
                        height: 30
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_v_row, {
                key: 1,
                "no-gutters": "",
                class: "mb-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "d-flex justify-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_img, {
                        src: _imports_1,
                        height: 30
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
        ]),
        default: _withCtx(() => [
          (_ctx.currentUser.id && _ctx.currentUser && _ctx.currentUser.profile)
            ? (_openBlock(), _createBlock(_component_v_list, {
                key: 0,
                lines: "one",
                nav: true,
                "base-color": "white",
                density: "compact",
                class: "space-y-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, { class: "v-list-item-title-active title primary--text" }, {
                        default: _withCtx(() => _cache[18] || (_cache[18] = [
                          _createTextVNode(" Mon Cabinet ")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (!_ctx.isAccountingEmployee)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 0,
                        to: { name: 'my-companies-edition', params: { type: 'company' } }
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[19] || (_cache[19] = [
                              _createTextVNode("$fa-home")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (!_ctx.mini)
                            ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                key: 0,
                                class: "v-list-item-title-active"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.selectedCompanyName), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_list_item, { to: { name: 'my-companies-edition', params: { type: 'users' } } }, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[20] || (_cache[20] = [
                          _createTextVNode("$fa-user")
                        ])),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      (!_ctx.mini)
                        ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                            key: 0,
                            class: "v-list-item-title-active",
                            "data-cy": "index-utilisateurs"
                          }, {
                            default: _withCtx(() => _cache[21] || (_cache[21] = [
                              _createTextVNode(" Utilisateurs ")
                            ])),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  (_ctx.currentUser.profile.configuration.engagementLetter.read)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 1,
                        to: { name: 'engagement-letters' }
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[22] || (_cache[22] = [
                              _createTextVNode("$oss-article")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (!_ctx.mini)
                            ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                key: 0,
                                class: "v-list-item-title-active"
                              }, {
                                default: _withCtx(() => _cache[23] || (_cache[23] = [
                                  _createTextVNode(" Lettres de mission ")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.selectedCompany.enableAccountingFirms)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 2,
                        to: { name: 'my-companies-edition', params: { type: 'accounting-firms' } }
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[24] || (_cache[24] = [
                              _createTextVNode("$fa-building")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (!_ctx.mini)
                            ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                key: 0,
                                class: "v-list-item-title-active"
                              }, {
                                default: _withCtx(() => _cache[25] || (_cache[25] = [
                                  _createTextVNode(" Mes cabinets ")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_list_item, { to: { name: 'my-companies-edition', params: { type: 'clients-companies' } } }, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[26] || (_cache[26] = [
                          _createTextVNode("$fa-building")
                        ])),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      (!_ctx.mini)
                        ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                            key: 0,
                            "data-cy": "index-mesDossiers",
                            class: "v-list-item-title-active"
                          }, {
                            default: _withCtx(() => _cache[27] || (_cache[27] = [
                              _createTextVNode(" Mes Dossiers ")
                            ])),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  (
                        _ctx.currentUser.profile.configuration.accountingWorkspace.read &&
                        _ctx.selectedCompany.accountingFirm &&
                        _ctx.selectedCompany.clientUserAccessRight === 'AVAILABLE_WORKSPACE'
                    )
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 3,
                        "data-cy": "index-mesDossiersGroupe",
                        to: {
                        name: 'my-companies-edition',
                        params: { type: 'accounting-workspaces' },
                    }
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[28] || (_cache[28] = [
                              _createTextVNode("$fa-building")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (!_ctx.mini)
                            ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                key: 0,
                                "data-cy": "index-mesGroupesDossiers",
                                class: "v-list-item-title-active"
                              }, {
                                default: _withCtx(() => _cache[29] || (_cache[29] = [
                                  _createTextVNode(" Mes groupes de dossiers ")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.currentUser.profile.configuration.accountingFirmSettings.read)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 4,
                        to: { name: 'configuration', params: { companyId: _ctx.selectedCompany.id } }
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[30] || (_cache[30] = [
                              _createTextVNode("$fa-building")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (!_ctx.mini)
                            ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                key: 0,
                                class: "v-list-item-title-active"
                              }, {
                                default: _withCtx(() => _cache[31] || (_cache[31] = [
                                  _createTextVNode(" Paramètres ")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["to"]))
                    : _createCommentVNode("", true),
                  (_ctx.currentUser.profile.configuration.accounting.monitoring)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 5,
                        to: { name: 'auditMonitoring' }
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[32] || (_cache[32] = [
                              _createTextVNode("$fa-chart-line")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (!_ctx.mini)
                            ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                key: 0,
                                "data-cy": "index-pilotage",
                                class: "v-list-item-title-active"
                              }, {
                                default: _withCtx(() => _cache[33] || (_cache[33] = [
                                  _createTextVNode(" Pilotage ")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (
                        _ctx.currentUser.profile.configuration.internalManagement.userActivity &&
                        !_ctx.isAccountingEmployee
                    )
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 6,
                        to: { name: 'users-activities' }
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[34] || (_cache[34] = [
                              _createTextVNode("$fa-chart-line")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (!_ctx.mini)
                            ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                key: 0,
                                class: "v-list-item-title-active"
                              }, {
                                default: _withCtx(() => _cache[35] || (_cache[35] = [
                                  _createTextVNode(" Activité ")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (
                        _ctx.currentUser.profile.configuration.internalManagement.userActivity &&
                        !_ctx.isAccountingEmployee
                    )
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 7,
                        to: { name: 'tutorials-activities' }
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[36] || (_cache[36] = [
                              _createTextVNode("$fa-chart-line")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (!_ctx.mini)
                            ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                key: 0,
                                class: "v-list-item-title-active"
                              }, {
                                default: _withCtx(() => _cache[37] || (_cache[37] = [
                                  _createTextVNode(" Suivi d'apprentissage ")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (
                        _ctx.currentUser.profile.configuration.declaration.read && _ctx.isAllowedToDeclaration
                    )
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 8,
                        to: { name: 'adminTaxForm' }
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[38] || (_cache[38] = [
                              _createTextVNode("$fa-file-invoice")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (!_ctx.mini)
                            ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                key: 0,
                                class: "v-list-item-title-active"
                              }, {
                                default: _withCtx(() => _cache[39] || (_cache[39] = [
                                  _createTextVNode(" Déclarations ")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_divider),
                  (_ctx.isSelfClient && !_ctx.isAccountingEmployee)
                    ? (_openBlock(), _createBlock(_component_v_list_item, { key: 9 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, { class: "v-list-item-title-active title primary--text" }, {
                            default: _withCtx(() => _cache[40] || (_cache[40] = [
                              _createTextVNode(" Ma compta ")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.isSelfClient && !_ctx.isAccountingEmployee)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 10,
                        to: { name: 'my-companies-edition', params: { type: 'accounting-period' } }
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[41] || (_cache[41] = [
                              _createTextVNode("$date_range")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (!_ctx.mini)
                            ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                key: 0,
                                class: "v-list-item-title-active"
                              }, {
                                default: _withCtx(() => _cache[42] || (_cache[42] = [
                                  _createTextVNode(" Exercice comptable ")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.isSelfClient && !_ctx.isAccountingEmployee)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 11,
                        to: { name: 'my-companies-edition', params: { type: 'bank' } }
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[43] || (_cache[43] = [
                              _createTextVNode("$fa-university")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (!_ctx.mini)
                            ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                key: 0,
                                class: "v-list-item-title-active"
                              }, {
                                default: _withCtx(() => _cache[44] || (_cache[44] = [
                                  _createTextVNode(" Banques ")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.isSelfClient && !_ctx.isAccountingEmployee)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 12,
                        to: { name: 'my-companies-edition', params: { type: 'legal' } }
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[45] || (_cache[45] = [
                              _createTextVNode("$gavel")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (!_ctx.mini)
                            ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                key: 0,
                                class: "v-list-item-title-active"
                              }, {
                                default: _withCtx(() => _cache[46] || (_cache[46] = [
                                  _createTextVNode(" Mentions légales ")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_divider),
                  _createVNode(_component_v_list_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, { class: "v-list-item-title-active title primary--text" }, {
                        default: _withCtx(() => _cache[47] || (_cache[47] = [
                          _createTextVNode(" Divers ")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.currentUser.profile.configuration.internalManagement.importEBIC)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 13,
                        to: { name: 'import-ebics' }
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[48] || (_cache[48] = [
                              _createTextVNode("$account_balance_wallet")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (!_ctx.mini)
                            ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                key: 0,
                                class: "v-list-item-title-active"
                              }, {
                                default: _withCtx(() => _cache[49] || (_cache[49] = [
                                  _createTextVNode(" Import EBICS ")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (
                        _ctx.selectedCompany.siren !== '844122648' &&
                        _ctx.currentUser.profile.configuration.internalManagement.bobbeeBilling
                    )
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 14,
                        to: { name: 'billing-bobbee' }
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[50] || (_cache[50] = [
                              _createTextVNode("$fa-file-invoice")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (!_ctx.mini)
                            ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                key: 0,
                                class: "v-list-item-title-active"
                              }, {
                                default: _withCtx(() => _cache[51] || (_cache[51] = [
                                  _createTextVNode(" Facturation bobbee ")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.enableAccountingRule && !_ctx.isBusinessClientWithSingleCompany)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 15,
                        to: { name: 'company-scopes' }
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[52] || (_cache[52] = [
                              _createTextVNode("$rule")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (!_ctx.mini)
                            ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                key: 0,
                                class: "v-list-item-title-active"
                              }, {
                                default: _withCtx(() => _cache[53] || (_cache[53] = [
                                  _createTextVNode(" Périmètre des règles ")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (
                        _ctx.selectedCompany.siren === '844122648' &&
                        _ctx.currentUser.profile.configuration.internalManagement.bobbeeBilling
                    )
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 16,
                        to: { name: 'bobbee-clients' }
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[54] || (_cache[54] = [
                              _createTextVNode("$fa-file-invoice")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (!_ctx.mini)
                            ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                key: 0,
                                class: "v-list-item-title-active"
                              }, {
                                default: _withCtx(() => _cache[55] || (_cache[55] = [
                                  _createTextVNode(" Clients bobbee ")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.currentUser.isRoot)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 17,
                        to: { name: 'companies-table' }
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[56] || (_cache[56] = [
                              _createTextVNode("$storefront")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (!_ctx.mini)
                            ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                key: 0,
                                class: "v-list-item-title-active"
                              }, {
                                default: _withCtx(() => _cache[57] || (_cache[57] = [
                                  _createTextVNode(" Companies ")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.currentUser.isRoot)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 18,
                        to: { name: 'tags' }
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[58] || (_cache[58] = [
                              _createTextVNode("$label")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (!_ctx.mini)
                            ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                key: 0,
                                class: "v-list-item-title-active"
                              }, {
                                default: _withCtx(() => _cache[59] || (_cache[59] = [
                                  _createTextVNode(" Tags ")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_list_item, { to: { name: 'partitionstags-table' } }, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[60] || (_cache[60] = [
                          _createTextVNode("$label")
                        ])),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      (!_ctx.mini)
                        ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                            key: 0,
                            class: "v-list-item-title-active"
                          }, {
                            default: _withCtx(() => _cache[61] || (_cache[61] = [
                              _createTextVNode(" Partitions génériques ")
                            ])),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_list_item, { to: { name: 'accounting-plans' } }, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[62] || (_cache[62] = [
                          _createTextVNode("$account_balance_wallet")
                        ])),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      (!_ctx.mini)
                        ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                            key: 0,
                            class: "v-list-item-title-active"
                          }, {
                            default: _withCtx(() => _cache[63] || (_cache[63] = [
                              _createTextVNode(" Plans comptables ")
                            ])),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  (_ctx.currentUser.isRoot)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 19,
                        to: { name: 'companyactivities-table' }
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[64] || (_cache[64] = [
                              _createTextVNode("$fa-university")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (!_ctx.mini)
                            ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                key: 0,
                                class: "v-list-item-title-active"
                              }, {
                                default: _withCtx(() => _cache[65] || (_cache[65] = [
                                  _createTextVNode(" Codes NAF ")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.currentUser.isRoot)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 20,
                        to: { name: 'wording-analysis' }
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[66] || (_cache[66] = [
                              _createTextVNode("$chat_bubble")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (!_ctx.mini)
                            ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                key: 0,
                                class: "v-list-item-title-active"
                              }, {
                                default: _withCtx(() => _cache[67] || (_cache[67] = [
                                  _createTextVNode(" Wordings ")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.currentUser.isRoot)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 21,
                        to: { name: 'partitionstags-table' }
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[68] || (_cache[68] = [
                              _createTextVNode("$list_alt")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (!_ctx.mini)
                            ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                key: 0,
                                class: "v-list-item-title-active"
                              }, {
                                default: _withCtx(() => _cache[69] || (_cache[69] = [
                                  _createTextVNode(" Partitions Tags ")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.currentUser.profile.configuration.profile.read)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 22,
                        to: { name: 'profiles-table' }
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[70] || (_cache[70] = [
                              _createTextVNode("$list_alt")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (!_ctx.mini)
                            ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                key: 0,
                                class: "v-list-item-title-active"
                              }, {
                                default: _withCtx(() => _cache[71] || (_cache[71] = [
                                  _createTextVNode(" Profils ")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.currentUser.profile.configuration.accounting.audit)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 23,
                        to: { name: 'auditChecks', params: { mode: 'displayOnly' } }
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[72] || (_cache[72] = [
                              _createTextVNode("$list_alt")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (!_ctx.mini)
                            ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                key: 0,
                                class: "v-list-item-title-active"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("menu." + "audit")), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.enableAccountingRule && _ctx.isAllowedToRevision)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 24,
                        to: { name: 'AccountingReviewLayoutsTable' }
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[73] || (_cache[73] = [
                              _createTextVNode("$list_alt")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (!_ctx.mini)
                            ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                key: 0,
                                class: "v-list-item-title-active"
                              }, {
                                default: _withCtx(() => _cache[74] || (_cache[74] = [
                                  _createTextVNode(" Dossiers de révision ")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.enableAccountingRule && _ctx.isAllowedToRestitution)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 25,
                        to: { name: 'booklet-templates' }
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[75] || (_cache[75] = [
                              _createTextVNode("$list_alt")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (!_ctx.mini)
                            ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                key: 0,
                                class: "v-list-item-title-active"
                              }, {
                                default: _withCtx(() => _cache[76] || (_cache[76] = [
                                  _createTextVNode(" Plaquettes ")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.enableAccountingRule && _ctx.offerType === _ctx.Offer_type.ACCOUNTING_PREMIUM)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 26,
                        to: { name: 'export-themes' }
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[77] || (_cache[77] = [
                              _createTextVNode("$list_alt")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (!_ctx.mini)
                            ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                key: 0,
                                class: "v-list-item-title-active"
                              }, {
                                default: _withCtx(() => _cache[78] || (_cache[78] = [
                                  _createTextVNode(" Thèmes documents ")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.enableAccountingRule)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 27,
                        to: { name: 'wording-analysis' }
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[79] || (_cache[79] = [
                              _createTextVNode("$fa-vial")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (!_ctx.mini)
                            ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                key: 0,
                                class: "v-list-item-title-active"
                              }, {
                                default: _withCtx(() => _cache[80] || (_cache[80] = [
                                  _createTextVNode(" Analyse de libellé ")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.enableAccountingRule && _ctx.isAllowedToInvoice)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 28,
                        to: { name: 'document-rule' }
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[81] || (_cache[81] = [
                              _createTextVNode("$fa-vial")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (!_ctx.mini)
                            ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                key: 0,
                                class: "v-list-item-title-active"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("menu.documentRules")), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.enableAccountingRule && _ctx.offerType === _ctx.Offer_type.ACCOUNTING_PREMIUM)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 29,
                        to: {
                        name: 'computedIndicatorTable',
                        params: { companyId: _ctx.selectedCompany.id },
                    }
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[82] || (_cache[82] = [
                              _createTextVNode("$fa-vial")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (!_ctx.mini)
                            ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                key: 0,
                                class: "v-list-item-title-active"
                              }, {
                                default: _withCtx(() => _cache[83] || (_cache[83] = [
                                  _createTextVNode(" Indicateurs personnalisés ")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["to"]))
                    : _createCommentVNode("", true),
                  (_ctx.enableAccountingRule && _ctx.offerType === _ctx.Offer_type.ACCOUNTING_PREMIUM)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 30,
                        to: { name: 'operatingAccountTable' }
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[84] || (_cache[84] = [
                              _createTextVNode("$fa-vial")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (!_ctx.mini)
                            ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                key: 0,
                                class: "v-list-item-title-active"
                              }, {
                                default: _withCtx(() => _cache[85] || (_cache[85] = [
                                  _createTextVNode(" Tableaux personnalisés ")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.currentUser.isRoot)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 31,
                        to: { name: 'companyCluster' }
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[86] || (_cache[86] = [
                              _createTextVNode("$fa-key")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (!_ctx.mini)
                            ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                key: 0,
                                class: "v-list-item-title-active"
                              }, {
                                default: _withCtx(() => _cache[87] || (_cache[87] = [
                                  _createTextVNode(" Groupement GK ")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.enableAccountingRule && _ctx.offerType === _ctx.Offer_type.ACCOUNTING_PREMIUM)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 32,
                        to: { name: 'export-office' }
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[88] || (_cache[88] = [
                              _createTextVNode("$oss-export")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (!_ctx.mini)
                            ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                key: 0,
                                class: "v-list-item-title-active"
                              }, {
                                default: _withCtx(() => _cache[89] || (_cache[89] = [
                                  _createTextVNode(" Export Office ")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_divider),
                  (_ctx.enableAccountingRule && _ctx.offerType === _ctx.Offer_type.ACCOUNTING_PREMIUM)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 33,
                        to: { name: 'extensions' }
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[90] || (_cache[90] = [
                              _createTextVNode("$fa-plug")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (!_ctx.mini)
                            ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                key: 0,
                                class: "v-list-item-title-active"
                              }, {
                                default: _withCtx(() => _cache[91] || (_cache[91] = [
                                  _createTextVNode(" Extensions ")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["rail"]),
      (_ctx.isAuth())
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _withDirectives(_createVNode(_component_router_view, {
              transition: "scroll-x-transition",
              class: "fill-height",
              style: {"width":"100%"}
            }, null, 512), [
              [_directive_scroll, _ctx.onScroll]
            ])
          ]))
        : (_openBlock(), _createBlock(_component_v_main, {
            key: 3,
            raw: "",
            fluid: "",
            xs12: "",
            class: "background_image d-flex align-start fill-height",
            style: {"width":"100%","margin":"0"}
          }, {
            default: _withCtx(() => [
              (_ctx.$route.name === 'document' && !_ctx.$vuetify.display.mobile)
                ? _withDirectives((_openBlock(), _createBlock(_component_router_view, {
                    transition: "scroll-x-transition",
                    key: _ctx.$route.fullPath
                  }, {
                    default: _withCtx(({ Component }) => [
                      _createVNode(_Transition, { name: "slide-fade" }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 1
                  })), [
                    [_directive_scroll, _ctx.onScroll]
                  ])
                : (!_ctx.$vuetify.display.mobile)
                  ? _withDirectives((_openBlock(), _createBlock(_component_router_view, {
                      key: 1,
                      transition: "scroll-x-transition"
                    }, {
                      default: _withCtx(({ Component }) => [
                        _createVNode(_Transition, { name: "slide-fade" }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 1
                    })), [
                      [_directive_scroll, _ctx.onScroll]
                    ])
                  : (_ctx.$route.name === 'document')
                    ? _withDirectives((_openBlock(), _createBlock(_component_router_view, {
                        key: 2,
                        transition: "scroll-x-transition",
                        class: "fill-height"
                      }, {
                        default: _withCtx(({ Component }) => [
                          _createVNode(_Transition, { name: "slide-fade" }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 1
                      })), [
                        [_directive_scroll, _ctx.onScroll]
                      ])
                    : _withDirectives((_openBlock(), _createBlock(_component_router_view, {
                        key: 3,
                        transition: "scroll-x-transition",
                        class: "fill-height"
                      }, {
                        default: _withCtx(({ Component }) => [
                          _createVNode(_Transition, { name: "slide-fade" }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 1
                      })), [
                        [_directive_scroll, _ctx.onScroll]
                      ])
            ]),
            _: 1
          })),
      (!_ctx.isAuth() && _ctx.env.ENABLE_COGNITO)
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 4,
            modelValue: _ctx.emailVerification,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.emailVerification) = $event)),
            "max-width": _ctx.$vuetify.display.mobile ? 'auto' : '40%',
            title: "Vérification de votre e-mail",
            "valid-title": 
                _ctx.emailConfirmationResent ? 'e-mail envoyé' : 'Renvoyer l\'e-mail de validation'
            ,
            "valid-disabled": _ctx.emailConfirmationResent,
            onValid: _cache[10] || (_cache[10] = ($event: any) => (_ctx.sendEmailConfirmation()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, { style: {"margin":"auto","padding":"10px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => _cache[93] || (_cache[93] = [
                      _createElementVNode("div", null, " Avant de continuer, vous devez valider votre e-mail. Nous vous avons envoyé un e-mail pour vérifier votre adresse e-mail. ", -1),
                      _createElementVNode("div", null, "Si vous ne voyez pas ce mail, vérifiez dans vos spams.", -1)
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "max-width", "valid-title", "valid-disabled"]))
        : _createCommentVNode("", true),
      _createVNode(_component_v_snackbar, {
        modelValue: _ctx.apolloErrorSnackBar,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.apolloErrorSnackBar) = $event)),
        color: _ctx.apolloErrors.type,
        "multi-line": "",
        timeout: "5000"
      }, {
        actions: _withCtx(() => [
          _createVNode(_component_v_btn, {
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.apolloErrorSnackBar = false)),
            variant: "text"
          }, {
            default: _withCtx(() => _cache[94] || (_cache[94] = [
              _createTextVNode(" Close ")
            ])),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.apolloErrors.errorType) + " : " + _toDisplayString(_ctx.apolloErrors.request) + " ", 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apolloErrors.messages, (msg, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(msg), 1))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "color"]),
      _createVNode(_component_SnackbarSurvey)
    ]),
    _: 1
  }))
}